<template>
  <div class="container top-level-div" style="">
    <h1 ref="pageTitle">Opportunities</h1>
    <hr>
    <!-- <div v-if="jobs.length > 0" class="mb-1">
      <app-map-board :items="jobs"></app-map-board>
    </div> -->

    <div v-if="jobs.length > 0">
      <app-job-list :jobs="jobs"></app-job-list>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import JobList from '../employers/jobs/JobList'
  import MapBoard from '../global/MapBoard'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data() {
      return {
        jobs: [],
      }
    },
    components: {
      appJobList: JobList,
      appMapBoard: MapBoard,
    },
    created() {
      // console.log('Job Board Created')
      this.getJobs()

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },3500)

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
    methods: {
      getJobs() {
        axios.get('/api/jobs/?agency='+this.$store.getters.agencyID)
          .then(res => {
            this.jobs = res.data
            this.jobs = this.jobs.sort((a, b) => (a.id < b.id) ? 1 : -1)

            // Only want to show jobs where the application deadline hasn't passed
            var activePostings = []
            let rightNow = new Date()
            for (var job in this.jobs) {
              // if (this.jobs[job].application_deadline) {
                // if (((new Date(this.jobs[job].application_deadline)) >= rightNow) && this.jobs[job].status !== 'draft') {
                if (this.jobs[job].status != 'Closed') {
                  activePostings.push(this.jobs[job])
                }
              // }
            }
            this.jobs = activePostings

            // console.log(this.jobs)
          })
          .catch(error => console.log(error))
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/jobBoard/JobBoard.vue